import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import liff from "./lib/liff";

liff
  .init({ liffId: process.env.REACT_APP_LINE_LIFF_ID })
  .then(() => {
    restoreLiffStatePath();
    if (liff.isLoggedIn()) {
      renderApp();
    } else {
      liff.login({ redirectUri: getCleanRedirectUri() });
    }
  })
  .catch((err) => {
    console.error("LIFF Initialization failed ", err);
    renderLiffError(err);
  });

function renderApp() {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

function restoreLiffStatePath() {
  const params = new URLSearchParams(window.location.search);
  const liffState = params.get("liff.state");

  if (!liffState || window.location.pathname !== "/") {
    return;
  }

  const restoredPath = decodeURIComponent(liffState);
  if (!restoredPath.startsWith("/")) {
    return;
  }

  window.history.replaceState(null, "", restoredPath + window.location.hash);
}

function getCleanRedirectUri() {
  const url = new URL(window.location.href);
  [
    "code",
    "state",
    "friendship_status_changed",
    "liffClientId",
    "liffRedirectUri",
    "liff.state",
  ].forEach((key) => url.searchParams.delete(key));
  return url.toString();
}

function renderLiffError(err) {
  const root = document.getElementById("root");
  if (!root) return;

  const liffUrl = `https://liff.line.me/${process.env.REACT_APP_LINE_LIFF_ID}/yofukashi/test-ticket`;
  root.innerHTML = `
    <main style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:#111;color:#fff;font-family:sans-serif;padding:24px;">
      <section style="width:100%;max-width:420px;">
        <h1 style="font-size:22px;margin:0 0 16px;">LINEログインを初期化できませんでした</h1>
        <p style="line-height:1.7;margin:0 0 16px;">LINEアプリ内で開き直してください。何度も表示される場合は、この画面の文言を運営に共有してください。</p>
        <a href="${liffUrl}" style="display:block;text-align:center;background:#06c755;color:#fff;text-decoration:none;font-weight:700;border-radius:8px;padding:14px 16px;margin:0 0 16px;">LINEで開き直す</a>
        <pre style="white-space:pre-wrap;overflow-wrap:anywhere;background:#222;color:#ddd;border-radius:8px;padding:12px;font-size:12px;">${escapeHtml(
          err?.message || String(err)
        )}</pre>
      </section>
    </main>
  `;
}

function escapeHtml(value) {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
